import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLang } from '../contexts/LangContext';
import './AlunaTabBar.css';
import useAppFeatures from '../hooks/useAppFeatures';

const TABS = [
  {
    key: 'hoje',
    label: { pt: 'Hoje', en: 'Today' },
    path: '/aluna/hoje',
    icon: (
      <svg viewBox="0 0 24 24"><path d="m4 11 8-7 8 7" /><path d="M6 10v10h12V10" /></svg>
    ),
  },
  {
    key: 'treino',
    label: { pt: 'Treino', en: 'Workout' },
    path: '/aluna/treino',
    icon: (
      <svg viewBox="0 0 24 24"><path d="M13 5.5a1.8 1.8 0 1 0 0-3.6 1.8 1.8 0 0 0 0 3.6Z" /><path d="m7 21 3.4-7.5 3.3 2.7 2.3 4.8" /><path d="m5 10.6 4-1.8 3.2 2.6 4.8.4" /><path d="m10.4 13.5 1.7-4.8" /></svg>
    ),
  },
  {
    key: 'jornada',
    label: { pt: 'Jornada', en: 'Journey' },
    path: '/aluna/jornada',
    icon: (
      <svg viewBox="0 0 24 24"><rect x="3" y="3" width="18" height="18" rx="5" /><circle cx="12" cy="12" r="3" /><path d="m16.5 7.5.01 0" /><path d="m7 18 3.2-3.5 2.3 2.2 2.2-2.4L18 18" /></svg>
    ),
  },
  {
    key: 'dieta',
    label: { pt: 'Nutrição', en: 'Nutrition' },
    path: '/aluna/nutricao',
    icon: (
      <svg viewBox="0 0 24 24"><path d="M7 3v8" /><path d="M5 3v8" /><path d="M9 3v8" /><path d="M5 11h4l-.5 10h-3L5 11Z" /><path d="M16 3v18" /><path d="M16 3c2 1.2 3 3 3 5.2 0 2-1 3.6-3 4.8" /></svg>
    ),
  },
  {
    key: 'chat',
    label: { pt: 'Chat', en: 'Chat' },
    path: '/aluna/chat',
    icon: (
      <svg viewBox="0 0 24 24"><path d="M21 11.5a8.4 8.4 0 0 1-1.1 4.2 8.7 8.7 0 0 1-7.6 4.3 8.4 8.4 0 0 1-4.2-1.1L3 20l1.1-5.1A8.4 8.4 0 0 1 3 10.7 8.7 8.7 0 0 1 7.3 3.1 8.4 8.4 0 0 1 11.5 2h.5a8.6 8.6 0 0 1 9 9v.5Z" /><path d="M8 10h8" /><path d="M8 14h5" /></svg>
    ),
  },
];

/**
 * Bottom tab bar flutuante em glass, seguindo o mock "tabbar-mock" do
 * design system v3. Usada em todas as telas principais do aluno
 * (Hoje, Treino/Nutrição dentro de AlunaDashboard, Perfil) pra dar a
 * sensação de navegação única do app, como nos mockups de referência.
 */
export default function AlunaTabBar({ current }) {
  const navigate = useNavigate();
  const { lang } = useLang();
  const { jornada } = useAppFeatures();
  const activeKey = current === 'saude' || current === 'perfil' ? 'hoje' : current;
  const visibleTabs = TABS.filter(item => item.key !== 'jornada' || jornada);
  return (
    <div className="aluna-tabbar-wrap">
      <nav className="aluna-tabbar" style={{ '--aluna-tab-count': visibleTabs.length }}>
        {visibleTabs.map(item => (
          <button
            key={item.key}
            className={`aluna-tabbar-item${activeKey === item.key ? ' active' : ''}`}
            onClick={() => navigate(item.path)}
          >
            {item.icon}
            <span>{item.label[lang] || item.label.pt}</span>
          </button>
        ))}
      </nav>
    </div>
  );
}
